import { Button, Checkbox, Dropdown, Menu, notification, Skeleton, Table } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useRouteMatch, useParams } from "react-router-dom"
import ColumnHeaderTitle from "../../../components/utilityComponents/table/ColumnHeaderTitle"
import moment from "moment"
import Role from "../../userRoles/Role"
import { EditOutlined, DownOutlined, DeleteOutlined, PlusOutlined, DownloadOutlined } from "@ant-design/icons"
import { fetchSupplyAccountNotes, generateCsv, selectSupplyAccountNotes, selectLoading, selectPagination, selectTotal, submitSupplyAccountNote } from "../supplyAccountNotesSlice"

export default function SupplyAccountNotesTable({ scopedByClient }) {
    const { url } = useRouteMatch()
    const { clientId, supplyAccountId } = useParams()

    const dispatch = useDispatch()

    const loading = useSelector(selectLoading)
    const notes = useSelector(selectSupplyAccountNotes)
    const total = useSelector(selectTotal)
    const pagination = useSelector(selectPagination)

    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (!loaded) {
            setLoaded(true)
            handleFetchInitialSupplyAccountNotes()
        }
    }, [loaded, url, dispatch, notes]) // eslint-disable-line

    const handleFetchInitialSupplyAccountNotes = (withFilters = false) => {
        if (!withFilters) {
            dispatch(fetchSupplyAccountNotes(clientId, supplyAccountId))
        }
        // else {
        //     dispatch(
        //         filterSupplyAccounts(
        //             {
        //                 clientId: clientId,
        //                 filters: filters,
        //                 pagination: pagination,
        //                 sort: sort,
        //             },
        //             { facilityId: facilityId }
        //         )
        //     )
        // }
    }

    const renderColumnHeaderTitle = (title, altTitle = null) => {
        return (
            <ColumnHeaderTitle
                title={title}
                altTitle={altTitle}
                // handleSortChange={handleSortSupplyAccountsChange} sort={sort}
            />
        )
    }

    const supplyAccountNotesCsv = () => {
        notification.open({
            message: "Supply account notes export started",
            duration: 2,
        })

        dispatch(generateCsv(clientId, supplyAccountId))
    }

    return (
        <div className="muc-table card">
            <div className="card-body">
                <div>
                    <div className="card-body-heading">
                        <div className="badged-header">
                            <h2>Supply Account Notes</h2>
                            <div className="badge">{notes.length}</div>
                        </div>
                        <div className="actions">
                            <div className="table-action-links">
                                {/* {renderResetFilters()} */}

                                <Link to={`/clients/${clientId}/supply_accounts/${supplyAccountId}/notes/new`}>
                                    <PlusOutlined />
                                    Add New
                                </Link>
                                
                                {/* <a href="javascript:;" onClick={() => console.log("Import")}>
                                    <UploadOutlined />
                                    Import
                                </a> */}

                                <a href="javascript:;" onClick={() => supplyAccountNotesCsv()}>
                                    <DownloadOutlined />
                                    Export
                                </a>
                            </div>
                        </div>
                    </div>

                    <Skeleton active loading={loading}>
                        <Table
                            dataSource={notes}
                            pagination={{ ...pagination, showSizeChanger: true, total: total, pageSizeOptions: [10, 20, 50, 100] }}
                            // onChange={handleTableChange}
                            rowKey={(r) => r.id}>
                            <Table.Column
                                width={"2%"}
                                // title={<Checkbox onChange={(e) => console.log(e.target.checked)} />}
                                title={"Alert"}
                                key="in"
                                dataIndex="in"
                                render={(text, record, index) => {
                                    return (
                                        <Checkbox
                                            checked={record.active}
                                            onChange={async (e) => {
                                                await dispatch(submitSupplyAccountNote({ active: e.target.checked, supply_account_id: supplyAccountId }, record.id, true))
                                            }}
                                            disabled={loading}
                                        />
                                    )
                                }}
                            />
                            <Table.Column
                                width={"90%"}
                                title={"Note"}
                                key="note"
                                dataIndex="note"
                            />
                            <Table.Column
                                width={"10%"}
                                title={"Created At"}
                                key="created_at"
                                dataIndex="created_at"
                                render={(text, record, index) => moment(text).format("L")}
                            />
                            <Table.Column
                                title="Manage"
                                key="action"
                                render={(text, record) => (
                                    <>
                                        <Dropdown
                                            overlay={
                                                <Menu>
                                                    <Role action="update" model="supply_account">
                                                        <Menu.Item key="1" icon={<EditOutlined />}>
                                                            <Link to={`/clients/${clientId}/supply_accounts/${supplyAccountId}/notes/${record.id}/edit`}>Edit Note</Link>
                                                        </Menu.Item>
                                                    </Role>
                                                    {/* <Role action="destroy" model="supply_account">
                                                        <Menu.Item key="2" icon={<DeleteOutlined />} onClick={() => console.log("delete")}>
                                                            Delete Note
                                                        </Menu.Item>
                                                    </Role> */}
                                                </Menu>
                                            }>
                                            <Button>
                                                Actions <DownOutlined />
                                            </Button>
                                        </Dropdown>
                                    </>
                                )}
                            />
                        </Table>
                    </Skeleton>
                </div>
            </div>
        </div>
    )
}
